// removed by extract-text-webpack-plugin
module.exports = {"header":"Mobile__header__2qa2a","nav-btn":"Mobile__nav-btn__TJKlV","nav-container":"Mobile__nav-container__2rBKb","body":"Mobile__body__3oGZu"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Header/Mobile/Mobile.scss
// module id = 697
// module chunks = 0